import { ReactElement, ReactNode } from 'react';
import { Device } from '@/api';
import { DevicesContext } from './context';

type DevicesProviderProps = {
    readonly devices: Device[];
    readonly children?: ReactNode;
};

export function DevicesProvider(props: DevicesProviderProps): ReactElement {
    const { children, devices } = props;

    return (
        <DevicesContext.Provider
            value={{
                devices: devices
            }}
        >
            {children}
        </DevicesContext.Provider>
    );
}
